import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-collapse';
import cn from 'classnames';
import { ReactComponent as ArrowImg } from './assets/collapseArrow.svg';

import styles from './styles.module.scss';

export default class HelpItemCollapse extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  };
  state = {
    show: false,
  };

  render() {
    const { title, content } = this.props;
    const { show } = this.state;

    return (
      <div className={styles.help_item}>
        <div className={styles.collapse_title} onClick={() => this.setState({ show: !show })}>
          <div className={cn(styles.collapse_icon, { [styles.active]: show })}>
            <ArrowImg />
          </div>
          <span>{title}</span>
        </div>
        <Collapse isOpened={show}>
          <div className={styles.spoiler_content}>{content}</div>
        </Collapse>
      </div>
    );
  }
}
